interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
  faqData?: Array<{ question: string; answer: string }>;
  articleData?: {
    headline: string;
    description: string;
    datePublished: string;
    dateModified: string;
    author: string;
    image: string;
    url: string;
  };
}

const baseUrl = 'https://goblin-cave-guide.readdy.site';

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '哥布林的洞窟',
  url: baseUrl,
  description: '哥布林的洞窟是一个充满神秘与危险的地下冒险世界，提供最全面的游戏攻略、角色解析、地图探索指南和剧情深度解读。',
  email: 'contact@goblin-cave-guide.readdy.site',
};

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '哥布林的洞窟——探索黑暗地下世界的终极指南',
  url: baseUrl,
  description: '哥布林的洞窟是一个充满神秘与危险的地下冒险世界，深度解析背景设定、角色特色、探索攻略与玩法技巧。',
};

export default function SchemaOrg({ type, data, faqData, articleData }: SchemaOrgProps) {
  let schema: Record<string, unknown>;

  switch (type) {
    case 'Organization':
      schema = { ...orgSchema, ...data };
      break;
    case 'WebSite':
      schema = { ...webSiteSchema, ...data };
      break;
    case 'WebPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        url: baseUrl,
        isPartOf: { '@type': 'WebSite', name: '哥布林的洞窟', url: baseUrl },
        ...data,
      };
      break;
    case 'Article':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: articleData?.headline || '',
        description: articleData?.description || '',
        datePublished: articleData?.datePublished || '',
        dateModified: articleData?.dateModified || '',
        author: { '@type': 'Person', name: articleData?.author || '' },
        publisher: { '@type': 'Organization', name: '哥布林的洞窟', url: baseUrl },
        image: articleData?.image || '',
        url: articleData?.url || baseUrl,
        ...data,
      };
      break;
    case 'FAQPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: (faqData || []).map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
        ...data,
      };
      break;
    default:
      schema = data || {};
  }

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}